import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabourJobService } from '../../labour-job/labour-job.service';
import { UtilityService } from '../../services/utility.service';
import { UserTimeSheetService } from 'src/app/services/user-time-sheet.service';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit {
  isDisabled = true
  commentData
  latestCommentData
  loading = false
  user = JSON.parse(localStorage.getItem('userRoles'))
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CommentsComponent>,
    public _labourjobService: LabourJobService,
    public _utilityService: UtilityService,
    public _usertimesheetService: UserTimeSheetService,
  ) { }

  ngOnInit(): void {
    console.log("COMMENT MODEL DATA", this.data)
  }


  // UTILITY

  enterRemark(event) {
    // console.log("ENTER REMARK EVENT", event)
    if (this.commentData) {
      // console.log("Remark added", this.commentData)
      this.isDisabled = false
    } else this.isDisabled = true
  }

  close() {
    this.dialogRef.close(this.data.remarks)
  }

  confirm(value) {
    console.log('fins refrance =====>', this.dialogRef);
    this.dialogRef.close(value);
  }



  // API CALL

  // Add remark in single job
  addRemark() {
    if (this.data.isTimesheet) this.addCommentInLog()
    else {
      let commentObj = {
        comment: this.commentData,
        jobId: this.data.jobId
      }
      this.loading = true
      this._labourjobService.addRemarkinJob(commentObj).subscribe((remarkAdded) => {
        console.log("NEW REMARK ADDED", remarkAdded)
        this.loading = false
        this.commentData = ''
        this.isDisabled = true
        this.data.remarks = remarkAdded
        this._utilityService.handleSnackBar({ msg: "Remark Added Successfully", button: "OK" })
      }, error => {
        console.log("ERROR WHILE ADD NEW REMARK", error)
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "Error while add remark", button: "OK" })
      })

    }
  }



  // Add comment in individual log of timesheet
  addCommentInLog() {
    this.loading = true
    let commentObj = {
      comment: this.commentData,
      userId: this.data.userId,
      logId: this.data.logId,
      date: this.data.date,
      jobTitle: this.data.jobtitle,
      notificationData: this.data.notificationData,
      urlDate: this.data.urlDate
      // clientList: this.data.clientList,
      // jobId: this.data.jobId
    }
    this._usertimesheetService.addCommentforLog(commentObj).subscribe((commentAdded) => {
      console.log("Comment Added", commentAdded)
      this.loading = false
      this.commentData = ''
      this.isDisabled = true
      this.latestCommentData = { success: commentAdded }
      let newComment = commentAdded.data.logs.find((x) => x._id == this.data.logId)
      this.data.remarks = newComment.remarks
      this._utilityService.handleSnackBar({ msg: "Remark Added Successfully", button: "OK" })
    }, error => {
      console.log("Error while add add comment", error)
      this.loading = false
      this.latestCommentData = { error: error }
      this._utilityService.handleSnackBar({ msg: "Error while add comment", button: "OK" })
    })
  }


}
